import React, { memo } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { FormattedDateTimeRange } from 'transfix-ui/components/FormattedDateTimeRange'
import { Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui/components/Tag'
import { Box, Typography } from 'transfix-ui/core'
import { DedicatedLanesResponse } from 'apps/marketplace/apiTypes/dedicatedLanes'
import { CalendarIcon, ShipmentsIcon } from 'transfix-icons'
import { RelativeDateTime } from 'transfix-ui'
import { LaneSummary } from './LaneSummary'

interface DedicatedLanesSummaryCardProps {
  dedicatedLane?: DedicatedLanesResponse
}

export const DedicatedLanesSummaryCard = memo<DedicatedLanesSummaryCardProps>(
  ({ dedicatedLane = {} }) => {
    const { endDate = '', startDate = '', volume } = dedicatedLane || {}
    return (
      <Card>
        <LaneSummary dedicatedLane={dedicatedLane} />
        <Box display='flex' pt={4} alignItems='center'>
          <CalendarIcon size='large' />
          <Box pl={2}>
            <Typography variant='body1'>
              <FormattedDateTimeRange
                startAt={startDate}
                startAtTimezone='America/New_York'
                endAt={endDate}
                endAtTimezone='America/New_York'
                format='dateAndYear'
              />
              <Box component='span' pl={2}>
                <Tag
                  label={
                    <RelativeDateTime
                      datetime={startDate}
                      endTime={endDate}
                      isShorthand={false}
                      inSentence={false}
                    />
                  }
                  size={TAG_SIZE.small}
                  tagStyle={TAG_STYLE.info}
                />
              </Box>
            </Typography>
          </Box>
        </Box>
        <Box display='flex' pt={3} alignItems='center'>
          <ShipmentsIcon size='large' />
          <Box pl={2}>
            <Typography variant='body1' data-test='dedicated-lanes-summary-card-volume'>
              Up to {volume} / week
            </Typography>
          </Box>
        </Box>
      </Card>
    )
  }
)
